import { useEffect } from 'react';
import { PropsWithChildren } from 'react';

import { useNavigate } from 'react-router';

import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Security } from '@okta/okta-react';

import oktaAuth from './oktaConfig';

const AuthSecurity = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate();

  // This apparently doesn't work, but the callback is required for <Security>
  // I looked in their source code real fast and couldn't find where it stores the originalUri if this
  // component redirects before hitting any SecureRoute components, which call setOriginalUri with okta.
  // Might because we have to use a custom SecureRoute?
  // Redirects are now handled in initializeApp.ts.
  // https://devforum.okta.com/t/restoreoriginaluri-callback-originaluri-is-undefined-in-chrome/32587
  const restoreOriginalUri = (_: OktaAuth, originalUri: string) => {
    if (originalUri) {
      navigate(toRelativeUrl(originalUri, window.location.origin), {
        replace: true,
      });
    } else {
      navigate('/');
    }
  };

  // https://github.com/okta/okta-react/issues/227 to address Two custom restoreOriginalUri callbacks are detected warning
  // This isn't an easily reproducible bug, apparently. There was some issue migrating to @okta/react v6.6.0 with react-router 6
  useEffect(
    () => () => {
      oktaAuth.options.restoreOriginalUri = undefined;
    },
    [],
  );

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  );
};

export default AuthSecurity;
